import { render, staticRenderFns } from "./personalTax.vue?vue&type=template&id=007892f4&scoped=true&"
import script from "./personalTax.vue?vue&type=script&lang=js&"
export * from "./personalTax.vue?vue&type=script&lang=js&"
import style0 from "./personalTax.vue?vue&type=style&index=0&id=007892f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007892f4",
  null
  
)

export default component.exports